import api from './auth';

export async function getArchives(dataType) {
  const res = await api.get('/archives/', { params: { data_type: dataType } });
  return res.data;
}

export async function addArchive(dataType, dataId) {
  const res = await api.post('/archives/', { data_type: dataType, data_id: dataId });
  return res.data;
}

export async function removeArchive(dataType, dataId) {
  const res = await api.delete('/archives/', { params: { data_type: dataType, data_id: dataId } });
  return res.data;
} 